function paramsBuilder (params) {
  const keys = Object.keys(params)
  let newParams = {}
  keys.forEach(key => {
    if (params[key]) {
      newParams[camelToUnderscore(key)] = params[key]
    }
  })

  return newParams
}

function camelToUnderscore (key) {
  return key.replace(/([A-Z])/g, '_$1').toLowerCase()
}

export default paramsBuilder
